import React from 'react';
import { Styles } from './style';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';

interface ContactsProps {
  nomeEmpresa?: string;
  endereco?: string;
  whatsapp?: string;
  email?: string;
}

const Contacts: React.FC<ContactsProps> = ({
  nomeEmpresa = 'Imobiliária Elite Prime',
  endereco = 'Rua Bonifácio de Oliveira Cassú, 284 - Éden Sorocaba/SP',
  whatsapp = '(15) 98137-0057',
  email = 'contato@imobiliariaeliteprime.com.br'
}) => {
  return (
    <Styles.ContactsContainer>
      <Styles.TopContainer>
        <Styles.Title>{nomeEmpresa}</Styles.Title>
      </Styles.TopContainer>

      <Styles.BaseContainer>
        <Styles.ContactInfo>
          <Styles.ContactBox>
            <LocationOnOutlinedIcon
              sx={{ width: '20px', height: '20px', color: '#ffffff' }}
            />
            <Styles.Text>{endereco}</Styles.Text>
          </Styles.ContactBox>

          <Styles.ContactBox>
            <LocalPhoneOutlinedIcon
              sx={{ width: '20px', height: '20px', color: '#ffffff' }}
            />
            <Styles.Text>{whatsapp}</Styles.Text>
          </Styles.ContactBox>

          <Styles.ContactBox>
            <EmailOutlinedIcon
              sx={{ width: '20px', height: '20px', color: '#ffffff' }}
            />
            <a href={`mailto:${email}`}>
              <Styles.Text style={{ color: '#9a998c' }}>{email}</Styles.Text>
            </a>
          </Styles.ContactBox>
          <Styles.MapInfo>
            <iframe
              src={`https://www.google.com/maps?q=${encodeURIComponent(endereco)}&output=embed`}
              style={{
                width: '100%',
                height: '100%',
                border: '0',
                borderRadius: '4px'
              }}
            />
          </Styles.MapInfo>
        </Styles.ContactInfo>
      </Styles.BaseContainer>
    </Styles.ContactsContainer>
  );
};

export default Contacts;
